/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

export const classify = {
  '1': {
    label: '撇口',
    value: 1,
    key: 1
  },
  '2': {
    label: '敛口',
    value: 2,
    key: 2
  },
  '3': {
    label: '敞口',
    value: 3,
    key: 3
  },
  '4': {
    label: '束口',
    value: 4,
    key: 4
  },
  '5': {
    label: '将军杯',
    value: 5,
    key: 5
  },
  '6': {
    label: '创新器型',
    value: 6,
    key: 6
  }
}

export const texture = {
  '1': {
    label: '兔毫',
    value: 1,
    key: 1
  },
  '2': {
    label: '鹧鸪斑',
    value: 2,
    key: 2
  },
  '3': {
    label: '油滴',
    value: 3,
    key: 3
  },
  '4': {
    label: '曜变',
    value: 4,
    key: 4
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js